<template>
  <el-table
    ref="tableRef"
    :header-cell-style="{
      background: '#f3f3f3',
    }"
    :data="dataList ?? []"
    :border="border"
    :height="height"
    :show-overflow-tooltip="overflowTooltip"
    style="border-radius: 4px"
    @row-click="rowHandleFn"
    @selection-change="onSelectionChange"
    :row-class-name="getRowClassName"
    :class="{ 'box-focus': isLisner, 'cust-curshou': isShouStyle }"
  >
    <el-table-column v-if="isIndex" type="index" width="60" label="序号" />
    <el-table-column v-if="isCheck" type="selection" width="50" />
    <el-table-column v-for="ele in headerList" :key="ele.property" v-bind="ele">
      <template #header>
        <slot :name="ele.label"></slot>
      </template>
      <template #default="scope" v-if="ele.useSlot">
        <slot :name="ele.property" :row="scope.row"></slot>
      </template>
    </el-table-column>
    <template #empty>
      <el-empty :image-size="100" description="暂无数据" />
    </template>
    <template #append>
      <slot name="append"></slot>
    </template>
  </el-table>
</template>

<script setup>
import { ref } from 'vue'
import SvgIcon from '@/components/SvgIcon/index.vue'
import { getUniqueRandomSet } from '@/libs/utils/data-jsFn'
import { isEmpty } from '@/libs/utils/data-checker'
const emit = defineEmits([
  'update:isShow',
  'closed',
  'rowClick',
  'selection-change',
])
const props = defineProps({
  // 患者信息
  isIndex: {
    type: Boolean,
    default: false,
  },
  isCheck: {
    type: Boolean,
    default: false,
  },
  border: {
    type: Boolean,
    default: true,
  },
  dataList: {
    type: Array,
    default: [],
  },
  headerList: {
    type: Array,
    default: [],
  },
  height: {
    type: String,
    default: null,
  },
  dataRef: {
    default: null,
  },
  overflowTooltip: {
    default: false,
  },
  isLisner: {
    default: false,
  },
  isShouStyle: {
    default: false,
  },
})
const rowHandleFn = row => {
  emit('rowClick', row)
}
const onSelectionChange = selection => {
  emit('selection-change', selection)
}
// const headerList = [
//   {
//     label: '中药处方',
//     property: 'name',
//     useSlot: true,
//     ele: {
//       'header-align': 'left',
//        width:'100',
//     },
//   },

// ]
// 当前页面实例
const instance = getCurrentInstance()
const tableRef = ref()
onMounted(() => {
  if (props.isLisner) {
    // 确保表格获得焦点
    nextTick(() => {
      window?.removeEventListener('keydown', handleKeydown)
      window?.addEventListener('keydown', handleKeydown)
    })
  }
})
onBeforeUnmount(() => {
  // 移除全局键盘事件监听
  window?.removeEventListener('keydown', handleKeydown)
})
const currentIndex = ref(0)
watch(
  () => props.dataList || [],
  newList => {
    currentIndex.value = 0
  },
  { immediate: true }
)
// 设置行类名
const getRowClassName = ({ row, rowIndex }) => {
  if (!props.isLisner) {
    return null
  }
  return rowIndex === currentIndex.value ? 'selected-row' : ''
}
// 处理键盘事件
function handleKeydown(event) {
  if (!props.isLisner) {
    return null
  }
  // 只处理上下方向键
  if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
    let newIndex = currentIndex.value
    if (event.key === 'ArrowUp') {
      // 向上键
      if (currentIndex.value > 0) {
        newIndex = currentIndex.value - 1
      } else {
        return
      }
    } else if (event.key === 'ArrowDown') {
      // 向下键
      if (currentIndex.value < props.dataList.length - 1) {
        newIndex = currentIndex.value + 1
      } else {
        return
      }
    }

    // 更新选中行
    currentIndex.value = newIndex
    // 滚动到选中的行（可选）
    scrollToRow(newIndex)
  }
  if (event.key === 'Enter') {
    if (!isEmpty(props.dataList)) {
      emit('rowClick', props.dataList[currentIndex.value] ?? {})
    }
  }
}
// 滚动到指定行
const scrollToRow = index => {
  nextTick(() => {
    const tableBody = tableRef.value.$el.querySelector(
      '.el-table__body-wrapper'
    )
    if (tableBody) {
      const rows = tableBody.querySelectorAll('tr')
      if (rows.length > index) {
        const targetRow = rows[index]
        targetRow.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    }
  })
}
</script>

<style lang="scss">
.cust-curshou {
  cursor: pointer;
}
// 启用方向键时，表格禁止hover样式
.box-focus {
  tbody tr:hover > td {
    background-color: transparent !important;
  }
}
.selected-row {
  background-color: var(--brown) !important;
  color: var(--white-text) !important;
}

:deep(.el-tooltip) {
  max-width: 500px;
  span {
    white-space: normal !important; /* 允许换行 */
  }
}
</style>
